import type { Router, RouteRecordRaw } from "vue-router"
import { ref } from "vue"
import { notFoundRoute } from "@/router/routes/basic"

/**
 * 获取当前路径匹配的route
 * @param router 当前vue-router实例
 * @param level 1:一级路由，2:二级路由，3:三级路由, ... 一级路由为 /xxx,二级路由为 /xxx/xxx,三级路由为 /xxx/xxx/xxx, ......
 * @returns
 */
export function getMatchedRoute(router: Router, level: number) {
  const currentPath = router.currentRoute.value.fullPath.replace(/^\//, "")
  const pathToMatch = "/" + currentPath.split("/").slice(0, level).join("/")
  const route = router.getRoutes().find((route) => route.path === pathToMatch)
  return route
}

export function getMatchedRouteInTargetRouteList(router: Router, targetRouteList: RouteRecordRaw[]) {
  const matchList = targetRouteList.filter((parentRoute) =>
    router.currentRoute.value.fullPath.includes(parentRoute.path),
  )
  // 返回matchList中匹配路径最长的
  const bestMatchRoute = matchList.reduce((prev, curr) => {
    return prev.path.length > curr.path.length ? prev : curr
  }, notFoundRoute)
  return bestMatchRoute
}

/**
 * @param router
 * @param targetRouteList
 * @returns
 */
export function getActiveRoute(router: Router, targetRouteList: RouteRecordRaw[]) {
  const bestMatchRoute = getMatchedRouteInTargetRouteList(router, targetRouteList)
  const currentIndex = targetRouteList.findIndex((route) => route.path === bestMatchRoute.path)
  const activeIndex = ref(currentIndex >= 0 ? currentIndex : 0)
  const handleRouteChange = () => {
    const route = targetRouteList[activeIndex.value]
    if (route) {
      router.push({ path: route.path })
    } else {
      router.push({ path: notFoundRoute.path })
    }
  }
  return {
    handleRouteChange,
    bestMatchRoute,
    activeIndex,
  }
}

export function getVisibleLevelTwoRoutes(routeList: RouteRecordRaw[]) {
  return routeList.filter(route => route.meta?.hideInLevelTwoTabs !== true)
}

export function injectProps(routeList: RouteRecordRaw[], props: any) {
  return routeList.map((route) => {
    route.props = props
    return route
  })
}

export function injectRouteList(routeList: RouteRecordRaw[]) {
  return routeList.map((route) => {
    route.props = {
      routeList,
    }
    return route
  })
}
